const detectTouch = {

	/**
	 * Init module
	 */
	init: () => {

        detectTouch.detect();
	},

	/**
	 * Detect touch screen
	 */
    detect: () => {

        if ("ontouchstart" in document.documentElement) {

            document.querySelector('body').classList.add('touch');
            window.isTouch = true;

        } else {

            document.querySelector('body').classList.add('no-touch');
            window.isTouch = false;
        }
    }
};

export default detectTouch;
